'use client';

import { useRouter } from 'next/router';
import _ from 'lodash';
import { getCookieClientOnly } from '@shared/functions/cookies';
import { useContext } from 'react';

export const useLocale = () => {
  const { locale } = useRouter();
  return { selectedLocale: locale };
};

export const useLocalesErpLegacy = (
  cookies: object | undefined = undefined,
) => {
  const locale = cookies
    ? _.get(cookies, 'preferred-locale', 'de')
    : getCookieClientOnly('preferred-locale');
  console.log('preferredLocale', locale);
  return {
    locale,
    locales: ['de', 'en', 'fr'],
  };
};
